<template>
  <div class="header-container">
    <div v-if="isShowHeader" class="app-inner">

      <div class="left-menu">
        <div v-if="env === 'uat'" class="header-env">UAT</div>

        <div class="store-select" @click="selectStore">
          {{ currCustomer.customerNumber }} {{ currCustomer.programType | filterPT }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </div>

        <div>
          <el-menu :default-active="activeMenu" mode="horizontal" text-color="#f4f4f4" active-text-color="#ffffff">
            <el-menu-item index="first">
              <router-link :to="{path:'/index', query: {type: 'first'}}" class="link">首页</router-link>
            </el-menu-item>
            <el-menu-item v-if="(currApps.RPT && currApps.RPT.length) || theme === 'tp'" index="report" :disabled="!currApps.RPT || !currApps.RPT.length">
              <router-link
                :to="{path:'/index', query: {type: 'report'}}"
                class="link"
                :disabled="!currApps.RPT || !currApps.RPT.length"
                :event="(currApps.RPT && currApps.RPT.length) ? 'click' : ''"
              >
                报表
              </router-link>
            </el-menu-item>
            <el-menu-item v-if="(currApps.ACD && currApps.ACD.length) || theme === 'tp'" index="info" :disabled="!currApps.ACD || !currApps.ACD.length">
              <router-link
                :to="{path:'/index', query: {type: 'info'}}"
                class="link"
                :disabled="!currApps.ACD || !currApps.ACD.length"
                :event="(currApps.ACD && currApps.ACD.length) ? 'click' : ''"
              >
                资料
              </router-link>
            </el-menu-item>
            <!-- v-if="currCustomer.programType === 'TYREPLUS'" -->
            <!-- v-if="currApps.SET && currApps.SET.length" -->
            <el-menu-item index="/setting">
              <router-link to="/setting" class="link">店面</router-link>
            </el-menu-item>
          </el-menu>
        </div>

        <span class="phone">支持热线：{{ theme === 'tp' ? staticInfo.TP.Tel_HotLine : staticInfo.NT.Tel_HotLine }}</span>
      </div>

      <div class="right-menu">
        <div class="name-container right-menu-item one_txt_cut">
          <span class="user-name one_txt_cut">{{ accountInfo.nickname }}</span>
          <span class="role">{{ currDcpRoles.roleName }}</span>
        </div>

        <!-- <div class="bell-container right-menu-item">
          <el-badge is-dot class="bell-dot" :hidden="isHideBellDot">
            <i class="el-icon-bell"></i>
          </el-badge>
        </div> -->

        <el-dropdown class="avatar-container right-menu-item" trigger="click" size="medium">
          <div class="avatar-wrapper">
            <div class="user-avatar-wrap flex-center"><span class="iconfont user-avatar">&#xe8a2;</span></div>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown" class="avatar-dropdown">
            <!-- <el-dropdown-item class="avatar-menu-item" @click.native="modifyPass">
              <p>
                <span class="iconfont iconfont-modifyPass">&#xe654;</span>
                修改密码
                <span v-if="accountInfo.modifyPassFlag === 'Y'" class="pass-expired">密码已过期</span>
              </p>
              <i class="el-icon-arrow-right" />
            </el-dropdown-item> -->
            <!-- <el-dropdown-item class="avatar-menu-item" @click.native="bindWeChat">
              <span>绑定微信</span>
              <i class="el-icon-arrow-right" />
            </el-dropdown-item> -->
            <!-- <el-dropdown-item class="avatar-menu-item" @click.native="logout">
              <span>绑定指纹</span>
              <i class="el-icon-arrow-right" />
            </el-dropdown-item>
            <el-dropdown-item class="avatar-menu-item" @click.native="logout">
              <span>隐私条款</span>
              <i class="el-icon-arrow-right" />
            </el-dropdown-item> -->

            <el-dropdown-item class="avatar-menu-item" @click.native="logout">
              <p class="logout-btn"><span class="iconfont iconfont-logout">&#xe608;</span>退出当前账号</p>
              <!-- <svg-icon icon-class="log-out" class="logout-icon" /> -->
              <i class="el-icon-arrow-right" />
            </el-dropdown-item>

            <!-- <div @click="logout">
              <el-button type="primary" class="logout-btn"><svg-icon icon-class="log-out" class="logout-icon" />退出当前账号</el-button>
              <p class="logout-btn"><svg-icon icon-class="log-out" class="logout-icon" />退出当前账号</p>
            </div> -->
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <ModifyPass :is-show.sync="isShowModifyPass"></ModifyPass>
  </div>
</template>

<script>
import ModifyPass from '@/components/ModifyPass/index'

import staticInfo from '@/helpers/staticInfo'

export default {
  name: 'Header',
  components: { ModifyPass },
  filters: {
    filterPT(val) {
      if (val.toLowerCase() === 'tyreplus') return '驰加'
      return val
    }
  },
  data() {
    return {
      loadingComponent: null,
      env: process.env.VUE_APP_ENV,
      isLoading: false,
      avatar: '',
      isShowModifyPass: false,
      staticInfo: staticInfo
    }
  },
  computed: {
    isShowHeader() {
      const route = this.$route
      const { path } = route

      return path !== '/stores'
    },
    isHideBellDot() {
      return false
    },
    activeMenu() {
      const route = this.$route
      const { path, query } = route

      return query.type || path
    },
    accountInfo() {
      return this.$store.getters.accountInfo
    },
    currDcpRoles() {
      return this.$store.getters.currDcpRoles[0]
    },
    currCustomer() {
      return this.$store.getters.currCustomer
    },
    currApps() {
      return this.$store.getters.currApps
    },
    theme() {
      return this.$store.getters.theme
    }
  },
  watch: {
    isLoading: function(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    }
  },
  methods: {
    selectStore() {
      this.gtag('event', 'usr_click_store_selection')

      this.$router.push('/stores')
    },
    modifyPass() {
      this.isShowModifyPass = true
    },
    logout() {
      const _this = this
      _this.$confirm('确认要登出吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        customClass: 'dcp-message-box',
        confirmButtonClass: 'dcp-message-box-confirm-btn',
        cancelButtonClass: 'dcp-message-box-cancel-btn'
      }).then(() => {
        _this.isLoading = true
        _this.$api.login.logoutOut().then(() => {
          _this.$store.dispatch('user/REMOVE_TOKEN').then(() => {
            this.gtag('event', 'usr_logout_success')

            _this.isLoading = false
            _this.$nextTick(() => {
              _this.$router.push(`/login?redirect=${_this.$route.fullPath}`)
            })
          })
        }).catch(() => {
          _this.isLoading = false
        })
      }).catch(() => {

      })
    },
    bindWeChat() {
      this.$notify.info({ title: '未开通', message: '功能开发中，敬请期待！' })
      // const h = this.$createElement
      // this.$msgbox({
      //   title: '',
      //   message: h('div', { style: 'text-align: left' }, [
      //     h('p', null, '功能开发中，敬请期待')
      //   ]),
      //   showCancelButton: false,
      //   center: true,
      //   customClass: 'dcp-message-box',
      //   confirmButtonClass: 'dcp-message-box-confirm-btn'
      // }).then(action => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  height: $headerHeight;
  position: fixed;
  top: 0;
  z-index: 10;

  .app-inner {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
  }

  @include background_color_page_primary('color');
}

.el-menu {
  min-width: 352px;
  background-color: transparent;

  &.el-menu--horizontal {
    border-bottom: none;

    > .el-menu-item {
      height: $headerHeight;
      // font-family: PingFangSC-Semibold, PingFang SC;
      padding: 0;
      font-size: 24px;
      line-height: $headerHeight;

      >.link {
        display: block;
        padding: 0 20px;
      }

      &.is-active {
        border-bottom: 6px solid $color-yellow;
        border-bottom-color: $color-yellow !important;
        font-weight: 600;
      }
    }
  }
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
  background-color: transparent;
}

.el-menu--horizontal > .el-submenu .el-submenu__title:hover,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  background-color: rgba($color: #fff, $alpha: .1);
}

.left-menu {
  float: left;
  display: flex;
  align-items: center;

  .header-env {
    margin-right: 30px;
    font-weight: 600;
    font-size: 28px;
    color: #fff;
  }

  .store-select {
    padding: 0 18px;
    margin-right: 20px;
    border-radius: 18px;
    font-weight: 600;
    font-size: 20px;
    line-height: 36px;
    background: $color-yellow;
    cursor: pointer;

    @include color_page_primary('font-color-diff');
  }

  .phone {
    margin-left: 20px;
    font-size: 14px;
    color: #fff;
  }
}

.right-menu {
  float: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: $headerHeight;
  padding-right: 20px;

  .right-menu-item {
    margin-left: 10px;
    font-size: $fontSizeLarger;
    color: #fff;
  }
}

.name-container {
  display: flex;
  align-items: baseline;
  max-width: 300px;

  .role {
    padding: 2px 6px;
    margin-left: 8px;
    border-radius: 4px;
    font-size: 14px;
    color: #906425;
    background-color: $color-yellow;
    // margin-top: -2px;
  }
}

.bell-container {
  cursor: pointer;

  .bell-dot {
    /deep/ .el-badge__content {
      top: 4px;
      right: 8px;
      border: none;
    }
  }
}

.avatar-container {
  position: relative;
  padding-left: 10px;

  .user-avatar-wrap {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;

    .user-avatar {
      font-size: 24px;
    }

    @include background_color_page_primary('user-bg');
  }

  .el-icon-caret-bottom {
    position: absolute;
    top: 25px;
    right: -20px;
    font-size: 12px;
    cursor: pointer;
  }
}

.avatar-dropdown {
  .avatar-menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    // font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #000;

    + .avatar-menu-item {
      border-top: 1px solid #ebeef5;
    }

    .iconfont {
      margin-right: 8px;
      font-size: 12px;
    }
  }

  .logout-btn {
    width: 152px;
    // height: 39px;
    // margin: 20px 17px 0;
    // font-size: $fontSizeSm;

    // .logout-icon {
    //   margin-right: 4px;
    //   font-size: 14px;
    // }

    // @include btn_page_primary('color');
  }
}

.pass-expired {
  padding: 2px 6px;
  margin: 0 4px;
  border-radius: 4px;
  font-size: 12px;
  color: #906425;
  background-color: $color-yellow;
  // @include color_page_primary('color');
  // @include background_color_page_primary('user-bg');
}
</style>
